import "bootstrap";
import Vue from "vue";
import axios from "axios";
import App from "./App.vue";
import router from "./router";
import "@/assets/styles/main.scss";
import "@/assets/styles/dashboard.scss";
import store from "./store";
import VueSkeletonLoader from "skeleton-loader-vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

Vue.use(axios);
Vue.config.productionTip = false;
Vue.component("vue-skeleton-loader", VueSkeletonLoader);
Vue.component("v-select", vSelect);

Vue.directive("only-number", {
  bind(el) {
    el.addEventListener("input", function () {
      this.value = this.value.replace(/[^0-9]/g, ""); // Hanya angka (0-9)
      this.dispatchEvent(new Event("input")); // Memastikan reaktivitas
    });
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
